import { CSSProperties, FC } from 'react'
import { TabsProps } from 'react-bootstrap'

import { Tabs } from './styles'

interface StyledTabsProps extends TabsProps {
  style?: CSSProperties
}

const StyledTabs: FC<StyledTabsProps> = (props) => (
  <Tabs {...props}>{props.children}</Tabs>
)

export default StyledTabs
